import ContactPerson from "./contactperson.model";

export default class Customer {

    constructor(data) {
        this.id = null;
        this.number = null;
        this.title = null;
        this.name = null;
        this.branch = null;
        this.tiein = null;
        this.dealer = null;
        this.note = null;
        this.phone = null;
        this.mobile = null;
        this.fax = null;
        this.email = null;
        this.street = null;
        this.zipcode = null;
        this.city = null;
        this.contactPersons = [];

        if (data) {
            Object.assign(this, data);

            if (this.contactPersons) {
                this.contactPersons = this.contactPersons.map((contactData)=> {
                    return new ContactPerson(contactData);
                });
            }
        }
    }

    hasAddress(){
        return this.street != null || this.zipcode != null || this.city != null;
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/model/customer.model.js